import apiClient from "./apiClient";


// CREATE PARTNER REQUEST
export const createPartnerRequest = async (payload) => {
    try {
        const response = await apiClient.post(
            "/partnerrequest",
            payload
        );

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};


// GET ALL PARTNER REQUESTS
export const getAllPartnerRequests = async () => {
    try {
        const response = await apiClient.get(
            "/partnerrequest_list"
        );

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};


// APPROVE PARTNER REQUEST
export const approvePartnerRequest = async (id) => {
    try {
        const response = await apiClient.put(
            `/partnerrequest_status/${id}`
        );

        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }

};